import { ErrorBoundary, GlobalHeader } from "@WahooFitness/wahoo-offline-mfe";
import { useMentalRecoveryPreferences } from "./useMentalRecoveryPreferences";
import { t } from "@lingui/macro";
import { Container } from "@mui/material";
import { useSettingsVersionedFeatures } from "@/hooks/useSettingsVersionedFeatures";

const MentalRecoveryPreferences: React.FC = () => {
  const { MentalRecoveryMedicalWarningContent, DailyMentalCheckInContent } =
    useMentalRecoveryPreferences();
  // The 24/7 Training Readiness widget's Mental Capacity gauge has its own entry point into
  // the same check-in flow, so this standalone toggle is a redundant second CTA once it's shown.
  const { enabled: recovery247Enabled } = useSettingsVersionedFeatures(
    "RECOVERY_247_MINPROFILE_VERSION"
  );

  return (
    <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
      <ErrorBoundary isLoading={false} error={false} onReload={() => {}}>
        <GlobalHeader title={t`Mental recovery preferences`} />
        <MentalRecoveryMedicalWarningContent />
        {!recovery247Enabled && <DailyMentalCheckInContent />}
      </ErrorBoundary>
    </Container>
  );
};

export default MentalRecoveryPreferences;
